import { render } from "./Coupon.vue?vue&type=template&id=4f30175e&scoped=true&ts=true&lang=pug"
import script from "./Coupon.vue?vue&type=script&lang=ts"
export * from "./Coupon.vue?vue&type=script&lang=ts"

import "./Coupon.vue?vue&type=style&index=0&id=4f30175e&lang=stylus&scoped=true"

import exportComponent from "/builds/CarrefourOneAPP/website/game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f30175e"]])

export default __exports__